import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actions as baselineTaskActions } from '../../../actions/baselineTaskActions';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Button from '../../Common/Button';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';
import Notification from '../../../components/Common/Notification';

class LocationAttributesForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchResults: [],
            selectedResults: [],
            selectedToReceive: [],
            isLoading: false,
            searchParams: {
                areaIds: [],
                brandIds: [],
                continentIds: [],
                countryIds: [],
                managementCompanyIds: [],
                typeIds: [],
                regionIds: [],
                openingStartDate: "",
                openingEndDate: ""
            },
            filters: {
                areas: [],
                brands: [],
                continents: [],
                countries: [],
                locationTypes: [],
                managementCompanies: [],
                regions: []
            }
        }
    }

    async componentDidMount() {
        await this.loadFilters();
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.projectId && this.props.projectId !== prevProps.projectId) {
            this.searchLocations();
        }
    }

    loadFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const result = await this.props.baselineTaskActions.loadBulkLocationAttribFilters();
            const payload = result.payload;
            if (result.type === types.LOAD_BULK_LOCATION_ATTRIB_FILTERS_SUCCESS) {
                this.setState({ filters: payload });
            } else if (result.type === types.LOAD_BULK_LOCATION_ATTRIB_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    searchLocations = async () => {
        if (this.props.isProjectsActive === true && this.props.isProjectIdRequiredForLocationTask === false && !this.props.projectId){
            await this.searchLocationsNoProject();
        } else {
            await this.searchLocationsByProject();
        }
    }

    searchLocationsByProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                ...this.state.searchParams,
                projectId: this.props.projectId,
                baselineId: this.props.baselineId
            }

            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearch(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS) {
                this.setState({ searchResults: payload.locations });
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    searchLocationsNoProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                ...this.state.searchParams,
                baselineId: this.props.baselineId,
                baselineTaskIdList: this.props.baselineTaskIds
            };
            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearchNoProject(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS) {
                this.setState({ searchResults: payload.locations });
                this.props.setSelectedLocations(this.state.searchResults.slice());
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onSelectChange = (csv, name) => {
        if (csv === "") {
            this.setState({ searchParams: { ...this.state.searchParams, [name]: []} });
        } else {
            this.setState({ searchParams: { ...this.state.searchParams, [name]: csv.split(",") } });
        }

    }

    onDateChange = (date, name) => {
        this.setState({ searchParams: { ...this.state.searchParams, [name]: date } });
    }

    onSelectSearchResult = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedResults: selected });
    }

    onSelectToReceivePushdown = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedToReceive: selected });
    }

    onAllDown = () => {
        this.props.setSelectedLocations(this.state.searchResults.slice());
    }

    onAllUp = () => {
        this.props.setSelectedLocations([]);
    }

    onSomeDown = () => {
        let toReceivePushdown = this.props.selectedLocations.slice();

        for (let i = 0; i < this.state.selectedResults.length; i++) {
            const option = this.state.selectedResults[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            if (!item) {
                toReceivePushdown.push({ id: option.id, name: option.name });
            }
        }
        this.props.setSelectedLocations(toReceivePushdown);
    }

    onSomeUp = () => {
        let toReceivePushdown = this.props.selectedLocations.slice();
        for (let i = 0; i < this.state.selectedToReceive.length; i++) {
            const option = this.state.selectedToReceive[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            const index = this.props.selectedLocations.indexOf(item);

            toReceivePushdown.splice(index, 1);

        }
        this.props.setSelectedLocations(toReceivePushdown);
    }

    renderResultList = () => {
        let options = [];
        this.state.searchResults.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    renderReceiveList = () => {
        let options = [];
        this.props.selectedLocations.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    render() {

        return (
            <div>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="row">
                        <div className="col-6"><MultiSelectBox name="brandIds" label="Brands" idField="id" valueField="name" options={this.state.filters.brands} selectedValues={this.state.searchParams.brandIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                        <div className="col-6"><MultiSelectBox name="managementCompanyIds" label="Management Companies" idField="id" valueField="name" options={this.state.filters.managementCompanies} selectedValues={this.state.searchParams.managementCompanyIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                    </div>
                    <div className="row">
                        <div className="col-6"><MultiSelectBox name="areaIds" label="Areas" idField="id" valueField="name" options={this.state.filters.areas} selectedValues={this.state.searchParams.areaIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                        <div className="col-6"><MultiSelectBox name="regionIds" label="Regions" idField="id" valueField="name" options={this.state.filters.regions} selectedValues={this.state.searchParams.regionIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                    </div>
                    <div className="row">
                        <div className="col-6"><MultiSelectBox name="countryIds" label="Countries" idField="id" valueField="name" options={this.state.filters.countries} selectedValues={this.state.searchParams.countryIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                        <div className="col-6"><MultiSelectBox name="continentIds" label="Continents" idField="id" valueField="name" options={this.state.filters.continents} selectedValues={this.state.searchParams.continentIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                    </div>
                    <div className="row">
                        <div className="col-6"><MultiSelectBox name="typeIds" label="Types" idField="id" valueField="name" options={this.state.filters.locationTypes} selectedValues={this.state.searchParams.typeIds.toString()} onChange={this.onSelectChange} isMulti={true} /></div>
                        <div className="col-6"></div>
                    </div>
                    <div className="row">
                        <div className="col-6"><DatePicker showIcon name="openingStartDate" value={this.state.searchParams.openingStartDate} label="Opening Start Date" onChange={this.onDateChange} /></div>
                        <div className="col-6"><DatePicker showIcon name="openingEndDate" value={this.state.searchParams.openingEndDate} label="Opening End Date" onChange={this.onDateChange} /></div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center"><Button name="option3-search" text="Search" bootstrapClass="primary" type="button" onClick={this.searchLocations} /></div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <span className="has-float-label">
                                <select id="searchResultsList" className="form-control mt-3" multiple size="8" defaultValue={[]} onChange={this.onSelectSearchResult}>
                                    {this.renderResultList()}
                                </select>
                                <p className="search-results-count">{this.state.searchResults.length} results</p>
                                <label htmlFor="searchResultsList">Search Results</label>
                            </span>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Button name="angle-double-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllDown} iconName="angle-double-down" />
                            <Button name="angle-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeDown} iconName="angle-down" />
                            <Button name="angle-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeUp} iconName="angle-up" />
                            <Button name="angle-double-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllUp} iconName="angle-double-up" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <span className="has-float-label">
                                <select id="toReceivePushdownList" className="form-control mt-3" multiple size="8" onChange={this.onSelectToReceivePushdown}>
                                    {this.renderReceiveList()}
                                </select>
                                <label htmlFor="toReceivePushdownList">Locations to Receive Tasks</label>
                            </span>
                        </div>
                    </div>
                </LoadingIndicator>


            </div>
        );
    }
}

LocationAttributesForm.propTypes = {
    baselineTaskActions: PropTypes.object.isRequired,
    setSelectedLocations: PropTypes.func.isRequired,
    selectedLocations: PropTypes.array.isRequired,
    projectId: PropTypes.string,
    baselineId: PropTypes.string.isRequired,
    baselineTaskIds: PropTypes.array.isRequired,
    isProjectsActive: PropTypes.bool.isRequired,
    isProjectIdRequiredForLocationTask: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(LocationAttributesForm);
